import download from "downloadjs";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import PDFPreview from "./PDFPreview";
import { generateCutsByColourPDF } from "../../utils/poster/posterPdfGenerator";

const PosterCard = () => {
  const retailer = useSelector((state) => state.retailer);
  const [cutsFileUrl, setCutsFileUrl] = useState();
  const [pdfBytes, setPdfBytes] = useState();
  const [loading, setLoading] = useState(false);

  const createCutsByColourPDF = async () => {
    setLoading(true);
    try {
      const { fileURL, pdfBytes } = await generateCutsByColourPDF(retailer);
      setCutsFileUrl(fileURL);
      setPdfBytes(pdfBytes);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCutsPdfActions = (action) => {
    if (action === "view") {
      window.open(cutsFileUrl);
    } else if (action === "download") {
      download(pdfBytes, "CUTS BY COLOUR", "application/pdf");
    }
  };

  useEffect(() => {
    createCutsByColourPDF();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PDFPreview
      title="CUTS BY COLOUR"
      fileUrl={cutsFileUrl}
      loading={loading}
      showEdit={false}
      onView={() => handleCutsPdfActions("view")}
      onDownload={() => handleCutsPdfActions("download")}
    />
  );
};

export default PosterCard;
